import { useMemo } from 'react'

import { useApiClient, useTokenManager } from 'clients/yogi-api'
import { ShareService } from 'features/share/service/service'

export { ShareService } from 'features/share/service/service'

export function useShareService(): ShareService {
  const client = useApiClient()
  const tokenManager = useTokenManager()
  return useMemo(
    () => new ShareService(client, tokenManager),
    [client, tokenManager],
  )
}
